(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comparison"] && !Shopify.designMode) return;
  try {
    
  if (!window.__nuveComparisonBound) {
    window.__nuveComparisonBound = true;

    document.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-cmp-tab]');
      if (!tab) return;

      const tablist = tab.closest('[role="tablist"]');
      const card = tablist?.parentElement?.querySelector('[data-testid="cmp-mobile-card"]');
      if (!tablist || !card) return;

      const side = tab.dataset.cmpTab;

      tablist.querySelectorAll('[data-cmp-tab]').forEach((button) => {
        const isActive = button === tab;
        button.setAttribute('aria-selected', String(isActive));
        button.classList.toggle('nuve-cmp__tab--active', isActive);
      });

      card.querySelectorAll('[data-cmp-rows]').forEach((list) => {
        list.hidden = list.dataset.cmpRows !== side;
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  if (!window.__nuveFaqBound) {
    window.__nuveFaqBound = true;

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-faq-toggle]');
      if (!button) return;

      const item = button.closest('.nuve-faq__item');
      const list = item?.closest('.nuve-faq__list');
      if (!item || !list) return;

      const wasOpen = button.getAttribute('aria-expanded') === 'true';

      list.querySelectorAll('.nuve-faq__item').forEach((otherItem) => {
        const otherButton = otherItem.querySelector('[data-faq-toggle]');
        const otherAnswer = otherItem.querySelector('.nuve-faq__answer');
        otherButton.setAttribute('aria-expanded', 'false');
        if (otherAnswer) otherAnswer.hidden = true;
      });

      if (!wasOpen) {
        button.setAttribute('aria-expanded', 'true');
        const answer = item.querySelector('.nuve-faq__answer');
        if (answer) answer.hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-guarantee-faq"] && !Shopify.designMode) return;
  try {
    
  if (!window.__nuveHomeFaqBound) {
    window.__nuveHomeFaqBound = true;

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-home-faq-toggle]');
      if (!button) return;

      const item = button.closest('.nuve-home-guarantee-faq__item');
      const list = item?.closest('.nuve-home-guarantee-faq__list');
      if (!item || !list) return;

      const wasOpen = button.getAttribute('aria-expanded') === 'true';

      list.querySelectorAll('.nuve-home-guarantee-faq__item').forEach((otherItem) => {
        const otherButton = otherItem.querySelector('[data-home-faq-toggle]');
        const otherAnswer = otherItem.querySelector('.nuve-home-guarantee-faq__answer');
        otherButton.setAttribute('aria-expanded', 'false');
        if (otherAnswer) otherAnswer.hidden = true;
      });

      if (!wasOpen) {
        button.setAttribute('aria-expanded', 'true');
        const answer = item.querySelector('.nuve-home-guarantee-faq__answer');
        if (answer) answer.hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["key-benefits"] && !Shopify.designMode) return;
  try {
    
  if (!window.__nuveBenefitsBound) {
    window.__nuveBenefitsBound = true;

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-benefits-toggle]');
      if (!button) return;

      const list = document.getElementById(button.getAttribute('aria-controls'));
      if (!list) return;

      const rows = list.querySelectorAll('[data-benefit-secondary-row]');
      if (!rows.length) return;

      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      rows.forEach((row) => {
        row.hidden = expanded;
      });

      const label = button.querySelector('[data-toggle-label]');
      if (label) {
        label.textContent = expanded ? button.dataset.expandLabel : button.dataset.collapseLabel;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"] && !Shopify.designMode) return;
  try {
    
  if (!window.__nuveHeroBound) {
    window.__nuveHeroBound = true;

    document.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-hero-thumb]');
      if (!thumb) return;

      const thumbs = thumb.closest('[data-hero-thumbs]');
      const sectionId = thumbs?.dataset.heroThumbs;
      const gallery = document.querySelector(`[data-hero-gallery="${sectionId}"]`);
      if (!gallery) return;

      const index = thumb.dataset.heroThumb;

      gallery.querySelectorAll('[data-hero-image]').forEach((image) => {
        image.hidden = image.dataset.heroImage !== index;
      });

      thumbs.querySelectorAll('[data-hero-thumb]').forEach((button) => {
        button.setAttribute('aria-current', String(button === thumb));
      });
    });

    window.nuveFormatMoney = function (scope, cents) {
      const currency = scope.dataset.currency || 'USD';
      const locale = scope.dataset.locale || 'en';
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
      } catch (error) {
        return `$${(cents / 100).toFixed(2)}`;
      }
    };

    window.nuveUpdateTotal = function (scope, qty) {
      const selected = scope.querySelector('[data-purchase-mode]:checked');
      const unitCents = Number(selected?.dataset.unitPriceCents || 0);
      const totalEl = scope.querySelector('[data-atc-total]');
      if (totalEl) totalEl.textContent = window.nuveFormatMoney(scope, unitCents * qty);
    };

    document.addEventListener('quantity-selector:update', (event) => {
      const scope = event.target.closest('.nuve-hero');
      if (!scope) return;
      window.nuveUpdateTotal(scope, event.detail.quantity);
    });

    document.addEventListener('change', (event) => {
      const radio = event.target.closest('[data-purchase-mode]');
      if (!radio) return;

      const scope = radio.closest('.nuve-hero');
      if (!scope) return;

      const unitCents = Number(radio.dataset.unitPriceCents || 0);
      const unitEl = scope.querySelector('[data-hero-unit-price]');
      if (unitEl) unitEl.textContent = window.nuveFormatMoney(scope, unitCents);

      const propEl = scope.querySelector('[data-purchase-property]');
      if (propEl) propEl.value = radio.dataset.label || '';

      const qtyInput = scope.querySelector('quantity-selector-component input[ref="quantityInput"]');
      window.nuveUpdateTotal(scope, Number(qtyInput?.value || 1));
    });

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-modal-open]');
      if (!trigger) return;
      const modal = document.getElementById(trigger.dataset.modalOpen);
      if (modal && typeof modal.open === 'function') modal.open();
    });
  }

  class NuveModal extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;

      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });

      this.querySelectorAll('[data-modal-close]').forEach((button) => {
        button.addEventListener('click', () => this.close());
      });

      // Native Escape fires 'cancel' then 'close' on a showModal()'d dialog —
      // default action already closes it; this just restores body scroll.
      this.dialog.addEventListener('close', () => {
        document.body.style.overflow = this._prevOverflow ?? '';
      });
    }

    open() {
      if (this.dialog.open) return;
      this._prevOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.dialog.showModal();
    }

    close() {
      if (this.dialog.open) this.dialog.close();
    }
  }

  if (!customElements.get('nuve-modal')) {
    customElements.define('nuve-modal', NuveModal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  if (!window.__nuveReviewsBound) {
    window.__nuveReviewsBound = true;

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-review-toggle]');
      if (!button) return;

      const card = button.closest('[data-testid^="review-"]');
      if (!card) return;

      const shortEl = card.querySelector('[data-review-short]');
      const fullEl = card.querySelector('[data-review-full]');
      if (!shortEl || !fullEl) return;

      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!expanded));
      shortEl.hidden = !expanded;
      fullEl.hidden = expanded;

      const label = button.querySelector('[data-toggle-label]');
      if (label) label.textContent = expanded ? 'More' : 'Less';
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-mobile-cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__nuveStickyCartBound) return;
    window.__nuveStickyCartBound = true;

    var bar = document.getElementById('sticky-mobile-cart');
    if (!bar) return;

    var heroSection = document.querySelector('[data-testid="product-hero"]');

    function formatMoney(cents) {
      var currency = bar.dataset.currency || 'USD';
      var locale = bar.dataset.locale || 'en';
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
      } catch (error) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    function currentQty() {
      var heroQtyInput = document.querySelector('.nuve-hero quantity-selector-component input[ref="quantityInput"]');
      return Number(heroQtyInput?.value || 1);
    }

    function syncFromHero() {
      var heroRadio = document.querySelector('.nuve-hero [data-purchase-mode]:checked');
      var unitCents = heroRadio ? Number(heroRadio.dataset.unitPriceCents || 0) : Number(bar.dataset.unitPriceCents || 0);
      var label = heroRadio ? heroRadio.dataset.label : bar.dataset.defaultLabel;
      var qty = currentQty();

      var modeEl = bar.querySelector('[data-sticky-mode]');
      var priceEl = bar.querySelector('[data-sticky-price]');
      var qtyInput = bar.querySelector('[data-sticky-quantity]');
      var propEl = bar.querySelector('[data-sticky-property]');

      if (modeEl && label) modeEl.textContent = label;
      if (priceEl) priceEl.textContent = formatMoney(unitCents * qty);
      if (qtyInput) qtyInput.value = String(qty);
      if (propEl && label) propEl.value = label;
    }

    document.addEventListener('quantity-selector:update', syncFromHero);
    document.addEventListener('change', function (event) {
      if (event.target.closest('[data-purchase-mode]')) syncFromHero();
    });

    syncFromHero();

    if (heroSection && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            bar.setAttribute('data-visible', String(scrolledPast));
            if (scrolledPast) {
              bar.hidden = false;
            } else {
              bar.hidden = true;
            }
          });
        },
        { threshold: 0 }
      );
      observer.observe(heroSection);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-rail"] && !Shopify.designMode) return;
  try {
    
  if (!window.__nuveVideoRailBound) {
    window.__nuveVideoRailBound = true;

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-video-play]');
      if (!button) return;

      const card = button.closest('[data-video-card]');
      const videoWrap = card?.querySelector('.nuve-video-rail__video-wrap');
      const video = videoWrap?.querySelector('video');
      if (!video) return;

      const isPlaying = button.getAttribute('aria-pressed') === 'true';

      document.querySelectorAll('[data-video-card]').forEach((otherCard) => {
        if (otherCard === card) return;
        const otherVideo = otherCard.querySelector('video');
        const otherWrap = otherCard.querySelector('.nuve-video-rail__video-wrap');
        const otherButton = otherCard.querySelector('[data-video-play]');
        if (otherVideo && !otherVideo.paused) {
          otherVideo.pause();
          otherWrap?.removeAttribute('data-playing');
          otherButton?.setAttribute('aria-pressed', 'false');
        }
      });

      if (isPlaying) {
        video.pause();
        videoWrap.removeAttribute('data-playing');
        button.setAttribute('aria-pressed', 'false');
      } else {
        videoWrap.removeAttribute('hidden');
        videoWrap.setAttribute('data-playing', 'true');
        video.play().catch(() => {});
        button.setAttribute('aria-pressed', 'true');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
